import * as Yup from 'yup';

export const UpdateBusinessInfoSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .min(8, 'Phone number must be at least 8 digits')
    .required('Please provide your phone number'),
  industryType: Yup.string()
    .min(1)
    .required('Please provide your industry type'),
  fleetSize: Yup.string()
    .min(1)
    .required('Please provide your fleet size'),
  typicalRoute: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Please select at least one route')
    .required('Please select your routes'),
  deliveryVehicleType: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Please select at least one vehicle')
    .required('Please select your vehicles'),
});

export type UpdateBusinessInfoDataType = Yup.InferType<typeof UpdateBusinessInfoSchema>;

type InitialValues = {
  phoneNumber: string;
  industryType: string;
  fleetSize: string;
  typicalRoute: string[];
  deliveryVehicleType: string[];
};

export const updateBusinessInfoInitialValues: InitialValues = {
  phoneNumber: '',
  industryType: '',
  fleetSize: '',
  typicalRoute: [],
  deliveryVehicleType: [],
};

export interface UpdateBusinessInfoInterface {
  phoneNumber: string;
  industryType: string;
  fleetSize: string;
  typicalRoute: string[];
  deliveryVehicleType: string[];
}
